module.exports = __webpack_public_path__ + "img/16129835921.EXIM.4fd8deb7.svg";